import { render, staticRenderFns } from "./custom-svg.vue?vue&type=template&id=f320b236"
import script from "./custom-svg.vue?vue&type=script&lang=js"
export * from "./custom-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports